import React, { useState } from "react";
import { Form, Input } from "antd";
import toast from "react-hot-toast";
import { VerifyMpinApi } from "../../api/request/users";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails, setloggedIn } from "../../store/Slices/userSlice";
import { setCookies } from "../../services/Cookies.jsx";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import ConfirmationModal from "../../components/modals/ConfirmationModal.jsx";

function Mpin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mpin, setMpin] = useState("");

  const finishLogin = (data) => {
    setCookies("token", data?.data?.access_token);
    dispatch(setloggedIn(true));
    const user = data?.data;
    delete user?.access_token;
    dispatch(setUserDetails(user));
    navigate("/dashboard");
  };

  const handleSubmit = async (allowMutiLogin) => {
    if (!localStorage.getItem("userId")) {
      toast.error("Login session expired. Please login again.");
      navigate("/");
      return;
    }
    if (!mpin || mpin.length < 6) {
      toast.error("Enter your 6-digit MPIN.");
      return;
    }
    try {
      setIsLoading(true);
      const { data } = await VerifyMpinApi({
        userId: localStorage.getItem("userId"),
        mpin,
        loginType: "web",
        allowMutiLogin: !!allowMutiLogin,
      });
      if (data?.error?.foundMultipleLogin) {
        setIsOpen(true);
      } else {
        finishLogin(data);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Something went wrong");
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-[#f9f9f9]" style={{ backgroundImage: "url('/assets/images/authbg.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
        <div className="rounded-2xl shadow-xl bg-[#FFFFFF]">
          <div className="flex flex-col justify-center items-center px-10 py-10 gap-6 w-full">
            <img src="/assets/logo/logo.png" alt="logo" className="h-10 w-48 object-contain" />
            <div className="text-center">
              <p className="text-[#2F2B3D] text-2xl font-semibold">Enter MPIN</p>
              <p className="text-[silver] text-sm font-medium mt-2">Enter your 6-digit MPIN to continue.</p>
            </div>
            <Form className="w-full" autoComplete="off" onFinish={() => handleSubmit(false)}>
              <Form.Item name="mpin" rules={[{ required: true, message: "Enter your MPIN." }]}>
                <Input.OTP length={6} value={mpin} onChange={(value) => setMpin(typeof value === "string" ? value : "")} style={{ width: "100%" }} />
              </Form.Item>
              <div className="mt-8">
                <LoadableButton type="submit" className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2" lable="Verify" isLoading={isLoading} loadingLable="Verifying..." />
              </div>
              <div className="primary flex items-center justify-center mt-5 text-sm">
                <a href="/">Back to login</a>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        message="User is already logged in on the website. Please log out before attempting to log in again."
        onConfirm={() => { setIsOpen(false); handleSubmit(true); }}
      />
    </>
  );
}

export default Mpin;
